export default function match(str, regexp) {
  return (str || '').match(regexp) || []
}
